// The draft-editable fields of a list (saved on submit), in one place so the
// draft and the diff stay in sync. isFavorite is deliberately excluded — like
// the item hero, it toggles immediately rather than through the draft.
const EDITABLE_FIELDS = ['title', 'description', 'coverImageUrl'];

// Editable snapshot of a list.
export function buildDraft(listInfo) {
  return {
    title: listInfo.title || '',
    description: listInfo.description || '',
    coverImageUrl: listInfo.coverImageUrl || '',
  };
}

// Patch of only the fields that actually changed.
export function diffDraft(listInfo, draft) {
  const patch = {};
  EDITABLE_FIELDS.forEach((field) => {
    if ((listInfo[field] || '') !== draft[field]) {
      patch[field] = draft[field];
    }
  });
  return patch;
}
